export const GET_INSTITUTES_REQUEST = 'GET_INSTITUTES_REQUEST';
export const GET_INSTITUTES_SUCCESS = 'GET_INSTITUTES_SUCCESS';
export const GET_INSTITUTES_FAILURE = 'GET_INSTITUTES_FAILURE';

export const GET_SCHOOLYEARS_REQUEST = 'GET_SCHOOLYEARS_REQUEST';
export const GET_SCHOOLYEARS_SUCCESS = 'GET_SCHOOLYEARS_SUCCESS';
export const GET_SCHOOLYEARS_FAILURE = 'GET_SCHOOLYEARS_FAILURE';

export const GET_NEXTSCHOOLYEAR_REQUEST = 'GET_NEXTSCHOOLYEAR_REQUEST';
export const GET_NEXTSCHOOLYEAR_SUCCESS = 'GET_NEXTSCHOOLYEAR_SUCCESS';
export const GET_NEXTSCHOOLYEAR_FAILURE = 'GET_NEXTSCHOOLYEAR_FAILURE';

export const GET_ACTUALSCHOOLYEAR_REQUEST = 'GET_ACTUALSCHOOLYEAR_REQUEST';
export const GET_ACTUALSCHOOLYEAR_SUCCESS = 'GET_ACTUALSCHOOLYEAR_SUCCESS';
export const GET_ACTUALSCHOOLYEAR_FAILURE = 'GET_ACTUALSCHOOLYEAR_FAILURE';

export const GET_PREVIOUSSCHOOLYEAR_REQUEST = 'GET_PREVIOUSSCHOOLYEAR_REQUEST';
export const GET_PREVIOUSSCHOOLYEAR_SUCCESS = 'GET_PREVIOUSSCHOOLYEAR_SUCCESS';
export const GET_PREVIOUSSCHOOLYEAR_FAILURE = 'GET_PREVIOUSSCHOOLYEAR_FAILURE';

export const GET_FEDERALSTATES_REQUEST = 'GET_FEDERALSTATES_REQUEST';
export const GET_FEDERALSTATES_SUCCESS = 'GET_FEDERALSTATES_SUCCESS';
export const GET_FEDERALSTATES_FAILURE = 'GET_FEDERALSTATES_FAILURE';

export const GET_CLASSIFICATIONTYPES_REQUEST = 'GET_CLASSIFICATIONTYPES_REQUEST';
export const GET_CLASSIFICATIONTYPES_SUCCESS = 'GET_CLASSIFICATIONTYPES_SUCCESS';
export const GET_CLASSIFICATIONTYPES_FAILURE = 'GET_CLASSIFICATIONTYPES_FAILURE';

export const GET_USAGETYPES_REQUEST = 'GET_USAGETYPES_REQUEST';
export const GET_USAGETYPES_SUCCESS = 'GET_USAGETYPES_SUCCESS';
export const GET_USAGETYPES_FAILURE = 'GET_USAGETYPES_FAILURE';

export const UPDATE_SCHOOLYEAR_REQUEST = 'UPDATE_SCHOOLYEAR_REQUEST';
export const UPDATE_SCHOOLYEAR_SUCCESS = 'UPDATE_SCHOOLYEAR_SUCCESS';
export const UPDATE_SCHOOLYEAR_FAILURE = 'UPDATE_SCHOOLYEAR_FAILURE';